import { render, staticRenderFns } from "./PanduanBelanja.vue?vue&type=template&id=00fcadd8&"
import script from "./PanduanBelanja.vue?vue&type=script&lang=js&"
export * from "./PanduanBelanja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports